// import Swiper core and required modules
import { Link } from "react-router-dom";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import bgImg1 from "../../assets/images/backgrounds/slider-1-1.jpg";
import bgImg2 from "../../assets/images/backgrounds/slider-1-2.jpg";
import bgImg3 from "../../assets/images/backgrounds/slider-1-3.jpg";
import BannerTitleIcon from "../../assets/images/icon/main-slider-sub-title-icon2.png";

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
  },
  loop: true,
  navigation: {
    nextEl: ".h1n",
    prevEl: ".h1p",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
};

function Banner() {
  return (
    <>
      {/* banner-one */}
      <section className="main-slider">
        <Swiper
          {...swiperOptions}
          className="swiper-container thm-swiper__slider"
        >
          <div className="swiper-wrapper">
            <SwiperSlide className="swiper-slide">
              <div
                className="main-slider__bg"
                style={{ backgroundImage: `url(${bgImg1})` }}
              />
              <div className="main-slider__shape-1" />
              <div className="main-slider__shape-2" />
              <div className="main-slider__shape-3" />
              <div className="main-slider__shape-4" />
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <div className="main-slider__sub-title-box">
                        <div className="main-slider__sub-title-icon">
                          <img src={BannerTitleIcon} alt="" />
                        </div>
                        <p className="main-slider__sub-title">
                          Elevate Smarter
                        </p>
                      </div>
                      <h2 className="main-slider__title">
                        Ride <span>Safer</span>
                        <br /> Powered by Innovation
                      </h2>
                      <p className="main-slider__text">
                        Backed by over 34 years of hands-on experience, <br />
                        <strong> Arch Elevators</strong> specializes in
                        cutting-edge elevator technology tailored to modern
                        infrastructure needs.
                        <br />
                        Our legacy is built on trust, reliability, and continual
                        innovation. .
                      </p>
                      <div className="main-slider__btn-and-call-box">
                        <div className="main-slider__btn-box">
                          <Link
                            to="/about"
                            className="thm-btn main-slider__btn"
                          >
                            Read more
                            <span />
                          </Link>
                        </div>
                        <div className="main-slider__call">
                          <div className="main-slider__call-icon">
                            <span className="icon-phone" />
                          </div>
                          <div className="main-slider__call-number">
                            <p>Need help?</p>
                            <h5>
                              <Link to="tel:+919033226011">
                                +91 90332 26011
                              </Link>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide className="swiper-slide">
              <div
                className="main-slider__bg"
                style={{ backgroundImage: `url(${bgImg2})` }}
              />
              <div className="main-slider__shape-1" />
              <div className="main-slider__shape-2" />
              <div className="main-slider__shape-3" />
              <div className="main-slider__shape-4" />
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <div className="main-slider__sub-title-box">
                        <div className="main-slider__sub-title-icon">
                          <img src={BannerTitleIcon} alt="" />
                        </div>
                        <p className="main-slider__sub-title">
                          Precision Engineering
                        </p>
                      </div>
                      <h2 className="main-slider__title">
                        Smooth <span>Performance</span>
                        <br /> Driven by Excellence
                      </h2>
                      <p className="main-slider__text">
                        From residential to commercial spaces, we engineer every
                        solution with <br />
                        precision, performance, and trust at its core. Our
                        systems are built to move <br />
                        people and possibilities—safely, smoothly, and with
                        lasting reliability.
                      </p>
                      <div className="main-slider__btn-and-call-box">
                        <div className="main-slider__btn-box">
                          <Link
                            to="/about"
                            className="thm-btn main-slider__btn"
                          >
                            Read more
                            <span />
                          </Link>
                        </div>
                        <div className="main-slider__call">
                          <div className="main-slider__call-icon">
                            <span className="icon-phone" />
                          </div>
                          <div className="main-slider__call-number">
                            <p>Need help?</p>
                            <h5>
                              <Link to="tel:+919033226011">
                                +91 90332 26011
                              </Link>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide className="swiper-slide">
              <div
                className="main-slider__bg"
                style={{ backgroundImage: `url(${bgImg3})` }}
              />
              <div className="main-slider__shape-1" />
              <div className="main-slider__shape-2" />
              <div className="main-slider__shape-3" />
              <div className="main-slider__shape-4" />
              <div className="container">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="main-slider__content">
                      <div className="main-slider__sub-title-box">
                        <div className="main-slider__sub-title-icon">
                          <img src={BannerTitleIcon} alt="" />
                        </div>
                        <p className="main-slider__sub-title">
                          Trusted Craftsmanship
                        </p>
                      </div>
                      <h2 className="main-slider__title">
                        Elevated <span>Experiences</span>
                        <br /> Rooted in Innovation
                      </h2>
                      <p className="main-slider__text">
                        From concept to installation, we deliver tailored
                        vertical mobility solutions <br /> designed for modern
                        spaces. With a focus on safety, aesthetics, and <br />
                        smart technology, we redefine how people move through
                        buildings.
                      </p>
                      <div className="main-slider__btn-and-call-box">
                        <div className="main-slider__btn-box">
                          <Link
                            to="/about"
                            className="thm-btn main-slider__btn"
                          >
                            Read more
                            <span />
                          </Link>
                        </div>
                        <div className="main-slider__call">
                          <div className="main-slider__call-icon">
                            <span className="icon-phone" />
                          </div>
                          <div className="main-slider__call-number">
                            <p>Need help?</p>
                            <h5>
                              <Link to="tel:+919033226011">
                                +91 90332 26011
                              </Link>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </div>
        </Swiper>
        <div className="swiper-pagination" id="main-slider-pagination" />
      </section>
      {/* banner-one */}
    </>
  );
}

export default Banner;
